<template>
  <v-card>
    <v-card-title>
      <v-spacer />
      <v-text-field
        v-model="pesquisar"
        append-icon="search"
        label="Pesquisar"
        single-line
        hide-details
      />
      <v-spacer />
    </v-card-title>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="conselhoUtils.headersIndicacao"
        :items="indicadosConselhos"
        :pagination.sync="pagination_conselho"
        :total-items="totalItems"
        :loading="!indicadosConselhos.length"
        :search="pesquisar"
        class="elevation-1"
      >
        <template
          slot="items"
          slot-scope="props"
        >
          <td>{{ props.item.cnpj_formatado }}</td>
          <td>{{ props.item.no_conselho }}</td>
          <td>{{ props.item.no_nome_votacao }}</td>
          <td>{{ props.item.nu_cpf }}</td>
          <td>
            <v-chip
              dark
              color="primary"
            >
              {{ props.item.no_uf_indicado }}
            </v-chip>
          </td>
          <td>
            <v-chip>
              {{ props.item.no_regiao_indicado }}
            </v-chip>
          </td>
          <td>
            <v-chip
              v-if="props.item.st_habilitacao == '1'"
              dark
              color="success">
              Habilitado
            </v-chip>
            <v-chip 
            v-else             
            dark
            color="error">
              Inabilitado
            </v-chip>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import conselhoUtils from '../utils/conselhoUtils';

export default {
  name: 'IndicacaoConselhoListaIndicados',
  data: () => ({
    pesquisar: '',
    tipoModal: '',
    conselhoUtils,
    pagination_conselho: {
      page: 1,
      rowsPerPage: 10,
      sortBy: 'no_conselho',
      descending: false,
    },
    totalItems: 0,
  }),
  computed: {
    ...mapGetters({
      indicadosConselhos: 'conselho/indicadosConselhos',
    }),
  },
  methods: {
    ...mapActions({
      obterListaIndicados: 'conselho/obterListaIndicados',
    }),
  },
  mounted() {
    this.obterListaIndicados();
  },
};
</script>
